import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  style: {"justify-content":"space-between","width":"80%"},
  class: "required-document flex"
}
const _hoisted_2 = {
  class: "align-items-center flex",
  style: {"flex":"1"}
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  style: {"display":"flex","flex":"1"},
  class: "align-items-center"
}
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolTip = _resolveComponent("ToolTip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: require('@/assets/icons/check.svg'),
        class: _normalizeClass({
          invisible: !_ctx.document.currentDocument,
          visible: _ctx.document.currentDocument,
        }),
        style: {"margin":"0 5px 0 0","height":"22px"}
      }, null, 10, _hoisted_3),
      _createElementVNode("p", {
        style: {"margin":"0"},
        class: _normalizeClass({ 'red-text': _ctx.document.currentDocument == null })
      }, _toDisplayString(_ctx.document.documentName), 3),
      _createVNode(_component_ToolTip, {
        "tooltip-text": _ctx.document.description ?? '',
        style: {"margin-left":"5px"},
        class: _normalizeClass({
          invisible: !_ctx.document.description,
          visible: _ctx.document.description,
        })
      }, null, 8, ["tooltip-text", "class"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (!_ctx.document.currentDocument)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "upload_link",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.triggerFileUpload && _ctx.triggerFileUpload(...args))),
            style: {"cursor":"pointer","margin-left":"5px"}
          }, "Upload"))
        : _createCommentVNode("", true),
      (!_ctx.document.currentDocument)
        ? (_openBlock(), _createElementBlock("input", {
            key: 1,
            type: "file",
            ref: "fileUpload",
            style: {"display":"none"},
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.uploadFile && _ctx.uploadFile(...args)))
          }, null, 544))
        : _createCommentVNode("", true),
      (_ctx.document.currentDocument)
        ? (_openBlock(), _createElementBlock("a", {
            key: 2,
            class: "download_link",
            style: {"cursor":"pointer","margin-left":"5px"},
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.downloadDocument && _ctx.downloadDocument(...args)))
          }, _toDisplayString(_ctx.document.currentDocument.fileName), 1))
        : _createCommentVNode("", true),
      (_ctx.document.currentDocument)
        ? (_openBlock(), _createElementBlock("img", {
            key: 3,
            src: require('@/assets/icons/delete-icon.svg'),
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.deleteDocument && _ctx.deleteDocument(...args))),
            style: {"cursor":"pointer","height":"30px"}
          }, null, 8, _hoisted_5))
        : _createCommentVNode("", true)
    ])
  ]))
}